import { ArrowUpRight } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { ResponsiveImage } from './ResponsiveImage';

export function ServiceCard({ service, image = false, imageSizes }) {
  return (
    <Link className={`service-card${image ? ' service-card--image' : ''}`} to={`/${service.slug}`}>
      {image && (
        <ResponsiveImage
          src={service.image}
          alt=""
          width="800"
          height="450"
          loading="lazy"
          sizes={imageSizes}
          style={{ objectPosition: service.imagePosition }}
        />
      )}
      <div className="service-card__body">
        <h3>{service.name}</h3>
        <p>{service.kicker}</p>
        <span>Explore service <ArrowUpRight aria-hidden="true" size={18} /></span>
      </div>
    </Link>
  );
}
